// Fetch list

export const FETCH = 'reportCustomerResults.FETCH'
export const FETCH_STARTED = 'reportCustomerResults.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCustomerResults.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCustomerResults.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCustomerResults.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportCustomerResults.CLEAR'

// Export

export const EXPORT = 'reportCustomerResults.EXPORT'
export const EXPORT_FULFILLED = 'reportCustomerResults.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportCustomerResults.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportCustomerResults.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportCustomerResults.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportCustomerResults.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportCustomerResults.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportCustomerResults.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportCustomerResults.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportCustomerResults.EXPORT_DETAILS_FULFILLED'
